import { useState } from "react";
import { Box, styled } from "@mui/material";
import { ILayout } from "./LayoutInterfaces";
import CssBaseline from "@mui/material/CssBaseline";
import { useStyles } from "./Layout.styles";
import AppDrawer, { drawerWidth } from "./AppDrawer/AppDrawer.view";

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })<{
    open?: boolean;
}>(({ theme, open }) => ({
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    }),
}));

const Layout = ({ children, appDrawerItems, toolbarLogo, appDrawerFooterItems, rca }: ILayout) => {
    const [isOpenAppDrawer, setIsOpenAppDrawer] = useState(true);
    const classes = useStyles();
    return (
        <Box className={classes.mainBox}>
            <CssBaseline />
            <AppDrawer
                rca={rca}
                isOpenAppDrawer={isOpenAppDrawer}
                setIsOpenAppDrawer={setIsOpenAppDrawer}
                appDrawerItems={appDrawerItems}
                appDrawerFooterItems={appDrawerFooterItems}
                toolbarLogo={toolbarLogo}
            />
            <Main open={isOpenAppDrawer}>{children}</Main>
        </Box>
    );
};

export default Layout;
